import React, { Component } from 'react'
import listhoc from './listhoc';
import { offers_api } from '../../actions/http';
import { applyCoupon, addToast, openModal } from '../../actions';
import moment from "moment";
import { apiInstance } from '../../actions/http';

class Offer extends Component {

    copyCode = (e) => {
        var copyText = e.target;
        copyText.select();
        document.execCommand("copy");
    }

    render() {
        let { code, title, image, description,  expired_on, offer, max_amount } = this.props
        return (
            <div className="order">
                <div className="row">
                    <div className="col-md-4">
                        <div className="flex-center offer-image">
                            <img src={image} alt="" />
                        </div>
                    </div>
                    <div className="col-md-8">
                        <h4 className="m-0">{title}</h4>
                        <p>{description}</p>
                        {offer && <p>{offer}% off upto &#8377;{max_amount}</p>}
                    </div>
                </div>
                <div className="row flex-between">
                    <div className="col-md-8">
                        <p className="m-0 font-bold">Expires on: {moment(expired_on).format('lll')}</p>
                    </div>
                    <div className="col-md-4">
                        <label className="flex-center offer-code">
                            <input className="copyinput" value={code || ''} readOnly onClick={this.copyCode} />
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}


export class Coupon extends React.Component{ 

    state = {
        err: '',
        fetching: false
    };

    handleCoupon = async () => {
        if(!this.props.user.token){
            this.props.dispatch(openModal("LOG_IN"));
            return; 
        }
        this.setState({fetching: true});
        try {
            let res = await apiInstance({
                url: `offer/${this.props.code}/validate_offer/`,
                method: 'get',
                headers: {
                    Authorization: `Token ${this.props.user.token}`
                }
            });
            if(res){
                this.setState({fetching: false})
                this.props.dispatch(applyCoupon(res.data));
            }
        } catch(err) {
            this.setState({fetching: false});
            this.props.dispatch(addToast("Invalid Coupon", false));
        }
    }


    render(){
        const {title, code, offer, max_amount} = this.props;
        return (
            <div className="col-md-6">
                <div className="order">
                    <b>{title}</b>
                    <p>Code: <b>{code}</b></p>
                    {offer && <p>{offer}% off upto &#8377;{max_amount}</p>}
                    <button 
                        disabled={this.state.fetching} 
                        className="btn btn-border" 
                        onClick={this.handleCoupon}
                    >
                        {this.state.fetching ? 'Checking...' : 'Apply Coupon'}
                    </button>
                </div>
            </div>
        )
    }
}

const OfferList = listhoc(Offer, "OFFERS", "offers", offers_api);

export const CouponList = listhoc(Coupon, "OFFERS", "offers", offers_api);

export default OfferList; 